const managerCookieBanners = {
    dismissedDefaultCookieBanner() {
        document.body.classList.add('cookie-dismissed');
        document.dispatchEvent(new Event("consentCookieDismissed"));
    },

    observeUntilFound({ root, selector, onFound }) {
        const attempt = () => {
            const element = root.querySelector(selector);
            if (element) {
                onFound(element);
                return true;
            }
            return false;
        };

        if (attempt()) return;

        const observer = new MutationObserver(() => {
            if (attempt()) observer.disconnect();
        });

        observer.observe(root, { childList: true, subtree: true });
    },

    addTermlyClickListeners(rootElement) {
        this.observeUntilFound({
            root: rootElement,
            selector: '[data-tid="banner-accept"]',
            onFound: () => {
                const declineButton = rootElement.querySelector('[data-tid="banner-decline"]');
                const acceptButton = rootElement.querySelector('[data-tid="banner-accept"]');

                const handleClick = () => {
                    const chatButton = document.querySelector('.amazon-chat-button');
                    if (chatButton) chatButton.style.bottom = '0';

                    const widget = document.getElementById('c-call-and-chat-widget');
                    if (widget) widget.style.bottom = '96px';
                };

                if (declineButton) declineButton.addEventListener('click', handleClick);
                if (acceptButton) acceptButton.addEventListener('click', handleClick);
            }
        });
    },

    manageAmazonConnectWidgetPosition() {
        const chatButton = document.querySelector('.amazon-chat-button');
        if (!chatButton) return;

        const banner = document.getElementById('termly-code-snippet-support');
        if (!banner) return;

        this.observeUntilFound({
            root: banner,
            selector: '.t-consentPrompt',
            onFound: (container) => {
                this.addTermlyClickListeners(banner);

                new ResizeObserver(entries => {
                    const { height } = entries[0].contentRect;
                    if (height > 0) {
                        chatButton.style.bottom = `${height}px`;
                    }
                }).observe(container);
            }
        });
    },

    manageCallAndChatWidgetPosition() {
        const widget = document.getElementById('c-call-and-chat-widget');
        if (!widget) return;

        const banner = document.getElementById('termly-code-snippet-support');
        if (!banner) return;

        this.observeUntilFound({
            root: banner,
            selector: '.t-consentPrompt',
            onFound: (container) => {
                this.addTermlyClickListeners(banner);

                new ResizeObserver(entries => {
                    const { height } = entries[0].contentRect;

                    if (height > 0) {
                        widget.style.bottom = `${height + 44}px`;
                    }
                }).observe(container);
            }
        });
    },

    checkForTermlyCookieBanner() {
        const tryHandleBanner = (banner) => {
            this.dismissedDefaultCookieBanner();
            this.manageAmazonConnectWidgetPosition();
            this.manageCallAndChatWidgetPosition();
        };

        const banner = document.getElementById('termly-code-snippet-support');
        if (banner) {
            tryHandleBanner(banner);
        } else {
            const observer = new MutationObserver((mutations, obs) => {
                for (const mutation of mutations) {
                    for (const node of mutation.addedNodes) {
                        if (node.nodeType !== 1) continue;

                        const isBanner = node.id === 'termly-code-snippet-support';
                        const nestedBanner = node.querySelector?.('#termly-code-snippet-support');

                        if (isBanner || nestedBanner) {
                            const foundBanner = isBanner ? node : nestedBanner;
                            tryHandleBanner(foundBanner);
                            obs.disconnect();
                            return;
                        }
                    }
                }
            });

            observer.observe(document.body, { childList: true, subtree: true });
        }
    },

    initialiseDefaultCookieBanner() {
        if (Cookies.get('cookieconsent_dismissed') === 'yes') {
            this.dismissedDefaultCookieBanner();
            return;
        }

        const dismissBtn = document.querySelector('.js-cookie-dismiss');
        if (dismissBtn) {
            dismissBtn.addEventListener('click', (e) => {
                e.preventDefault();
                Cookies.set('cookieconsent_dismissed', 'yes', { expires: 365 });
                this.dismissedDefaultCookieBanner();
            });
        }
    },

    init() {
        this.initialiseDefaultCookieBanner();
        this.checkForTermlyCookieBanner();
    }
};
